module.exports = __webpack_public_path__ + "img/KZ.467a8a29.svg";